import { Stack, Card, CardContent } from '@mui/material';
import Link from 'next/link';
import InvestmentOverview from '../investment/InvestmentOverview';
import InvestmentStatus from '../investment/InvestmentStatus';
import PlanInfoMedia from './PlanInfoMedia';
import PlanInfoSummary from './PlanInfoSummary';
import { PdpInfoDTO } from '@/types/models';
import { slugify } from '@/utils/function';
interface planInfoProps {
  data: PdpInfoDTO;
  hasDetail?: boolean;
}
const PlanInfo = ({
  data,
  hasDetail
}: planInfoProps) => {
  return <Card sx={{
    display: 'flex',
    flexDirection: 'column',
    bgcolor: 'background.bg',
    borderRadius: 'var(--corner_radius_xl)',
    width: '100%',
    maxWidth: {
      xs: '379px',
      md: 'unset'
    },
    m: {
      xs: 'auto',
      md: 'unset'
    }
  }} component={Link} href={`/crowdfunding/details/${data.id}/${slugify(data.title || '')}`} data-sentry-element="Card" data-sentry-component="PlanInfo" data-sentry-source-file="PlanInfo.tsx">
      <PlanInfoMedia data={data} data-sentry-element="PlanInfoMedia" data-sentry-source-file="PlanInfo.tsx" />

      <CardContent sx={{
      p: '0 !important',
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--spacing_m)'
    }} data-sentry-element="CardContent" data-sentry-source-file="PlanInfo.tsx">
        <InvestmentOverview data={data} hasDetail={hasDetail} data-sentry-element="InvestmentOverview" data-sentry-source-file="PlanInfo.tsx" />
      </CardContent>

      <Stack width='100%' data-sentry-element="Stack" data-sentry-source-file="PlanInfo.tsx">
        <PlanInfoSummary data={data} data-sentry-element="PlanInfoSummary" data-sentry-source-file="PlanInfo.tsx" />
        <InvestmentStatus data={data} data-sentry-element="InvestmentStatus" data-sentry-source-file="PlanInfo.tsx" />
      </Stack>
    </Card>;
};
export default PlanInfo;